class RoleVariable {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.name = data.name || "";
    this.role_variables_id = data.role_variables_id || null;
    this.events_custom_instances_id = data.events_custom_instances_id || null;
    this.events_custom_field_blocks_id = data.events_custom_field_blocks_id || null;
    this.events_custom_forms_id = data.events_custom_forms_id || null;
    this.events_custom_forms_products_id = data.events_custom_forms_products_id || null;
  }
}

export default RoleVariable;
